var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataList[0])?_c('x-y-chart',{staticStyle:{"height":"100%","padding":"10px"},attrs:{"data-config":_vm.dataList[0],"unit-prop":_vm.unitProp,"chart-type":"bar","stack-type":0,"data-time-format":"MM月DD日HH时","download-name":"PM2.5和重金属","chart-min-height":"300px","chart-height":"auto"}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ff1d534","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/02Data-Audit/01Manual/AuditDeviceViews/AuditHeavyMetalDeviceCompareChart.vue
// module id = null
// module chunks = 